import {
    required,
    maxLength,
    between,
    integer,
    numeric,
    requiredIf,
    helpers
} from 'vuelidate/lib/validators';
import store from '@/store/index';

export default {
    importerOfRecord: {
        maxLength: maxLength(50)
    },
    receiverPays: {
        transportProduct: {
            required: requiredIf((inst) => {
                const isDangerousGoods = store.getters['createShipment/isReceiverPays'];
                return isDangerousGoods;
            })
        },
        accountNumber: {
            required: requiredIf((inst) => {
                const isDangerousGoods = store.getters['createShipment/isReceiverPays'];
                return isDangerousGoods;
            })
        }
    }
};
